import { Icon  } from 'office-ui-fabric-react/lib/Icon';
import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { DetailsList, DetailsListLayoutMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Table } from "react-bootstrap";
import {getItemsInProgress} from "../components/Requests/Requests"
import { 
    PageLayout,
  StandardScreen,
  StandardSearchBox, 
  StatusMessage
} from '../components/Layout';

class ItemProgress extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            columns:[],
            showTable: false,
            items: [],
            sortAscending: true,
            sortColumnName: true,
            activeItem: null,
            showModal: false,
            isDraggable: false,
            rowItem: {},
            loading: false,
            error:"",
            searchValue: ""
        }
    }
  
 getItemsInProgress(spHostUrl) {
        if (!spHostUrl || spHostUrl.trim() === '') {
            this.setState({ error: "Please enter a SPHostUrl to search", loading: false });
            return;
        }
        
        this.setState({loading:true, error:"", showTable: false})
        getItemsInProgress(this.props.accessToken, spHostUrl).then((response) => {
                if (response.status === 200) {
                    response.json().then((data) => {
                        this.createHeadersAndRows(data);
                    });
                } else {
                    this.setState({loading:false,error:"Something went wrong"});
                }
            }).catch((error) => {
                console.error('Error fetching items in progress:', error);
                this.setState({ error: "An error occurred while fetching data", loading: false });
            });
        }

 createHeadersAndRows = (data) =>{
     console.log(data);
     
     if (data.length > 0 && data !== undefined && data !== null) {
        let columns = [];
        Object.keys(data[0]).forEach(key => {
            columns.push({
                key: key,
                name: key,
                fieldName: key,
                minWidth: 100,
                maxWidth: 100,
                isSorted:  key === 'date' ? true : false,//can make this property mutable for specific columns, so that the arrow isn't shown om every column
                isSortedDescending: true, //this is for negating the current form of ordering.
                isResizable: true,
                data: 'string',//was number
                value: 'No Results',
                compact: true,
                onColumnClick: this.onColumnClick,//calls the method that handles the column clicks
                onRender: this._renderCellColumn.bind(this)
            });  
        }); 
        this.setState({columns:columns,items:data,showTable:true,loading:false,error:""});
    }else {
        this.setState({loading:false,error:"No items in progress for the provided SPHostUrl"});
    }
  }

 _renderCellColumn(row, something_we_do_not_understand, column){ 
    for (const [key, value] of Object.entries(row)) {
        if(column.key === key){
            return <span>{value}</span>
        }   
    }
  }

  onColumnClick = () => {
      //alert('column clicked');
  }

 onRowClick = (item, index, ev) => {
    let target = ev.target; 
    let content = target.innerText;
    window.prompt("Copy to clipboard: Ctrl+C, Enter", content);
  }

 render() {
    return (
        <PageLayout>
            <StandardScreen
                title="Items in Progress"
                description={
                    <span>
                        This table will display current provisioning items relating to the custodian url supplied in the search bar.
                        <span style={{ fontWeight: 900 }}> Double click on table field to copy value.</span>
                    </span>
                }
                loading={this.state.loading}
            >
                <StandardSearchBox
                    label="SPHostUrl"
                    placeholder="Enter SPHostUrl to search..."
                    value={this.state.searchValue}
                    onChange={newValue => this.setState({
                        searchValue: newValue,
                        error: "",
                        showTable: false
                    })}
                    onSearch={newValue => this.getItemsInProgress(newValue)}
                />

                {this.state.error && (
                    <StatusMessage type="error">
                        {this.state.error}
                    </StatusMessage>
                )}

                {!this.state.showTable && !this.state.loading && !this.state.error && (
                    <div style={{
                        textAlign: 'center',
                        padding: '40px',
                        color: '#666'
                    }}>
                        <Icon iconName="GroupedDescending" style={{ fontSize: '48px', marginBottom: '16px' }} />
                        <div>Enter a SPHostUrl above to search for items in progress</div>
                    </div>
                )}

                {this.state.showTable && (
                    <div style={{ marginTop: '20px' }}>
                        <Table striped hover>
                            {this.updateTable()}
                        </Table>
                    </div>
                )}
            </StandardScreen>
        </PageLayout>
    );
  }

 updateTable = () =>{
      return (
        <div className="listContainer">   
            <div className="" data-is-scrollable="true">
            <DetailsList onItemInvoked={this.onRowClick} layoutMode={DetailsListLayoutMode.fixedColumns} onActiveItemChanged={this.onColumnClick} onColumnHeaderClick={this.onColumnClick} items={this.state.items} columns={this.state.columns} ></DetailsList>
            </div>
        </div>
      )
  }
}

export default ItemProgress;



